import Head from './Head';

export default Head;
export * from './Head';
